import axios from "axios";

// export const FLEET_API_BASE_URL = "http://localhost:4000/api/v1";
export const FLEET_API_BASE_URL = "https://fleet-apis.tdcp.gop.pk/api/v1"

export const getFleetMediaUrl = (pathOrUrl) => {
  if (!pathOrUrl) return "";
  if (/^https?:\/\//i.test(pathOrUrl)) return pathOrUrl;

  try {
    const origin = new URL(FLEET_API_BASE_URL).origin;
    const normalizedPath = pathOrUrl.startsWith("/") ? pathOrUrl : `/${pathOrUrl}`;
    return `${origin}${normalizedPath}`;
  } catch {
    return pathOrUrl;
  }
};

export const extractFleetMediaFilename = (pathOrUrl) => {
  if (!pathOrUrl) return "";

  try {
    const parsed = new URL(pathOrUrl);
    return parsed.pathname.split("/").filter(Boolean).pop() || "";
  } catch {
    const clean = String(pathOrUrl).split("?")[0];
    return clean.split("/").filter(Boolean).pop() || "";
  }
};

export const getFleetUploadRelativeUrl = (uploadResult, index = 0) => {
  if (!uploadResult) return "";

  if (typeof uploadResult === "string") {
    return uploadResult;
  }

  if (Array.isArray(uploadResult?.files)) {
    return uploadResult.files?.[index]?.url || "";
  }

  return uploadResult?.url || uploadResult?.file?.url || "";
};

export const fleetManagementApi = axios.create({
  baseURL: FLEET_API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
    // Authorization: `Bearer ${localStorage.getItem("token")}`,
  },
});

fleetManagementApi.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  }
);

fleetManagementApi.interceptors.response.use(
  (response) => response?.data?.data,
  (error) => {
    // if (error.response && error.response.status === 401) {
    //   localStorage.removeItem("token");
    //   window.location.href = "/login";
    // }
    return Promise.reject(error);
  }
);